import { LoaderCircle } from 'lucide-react';

const DeleteConfirmModal = ({ isOpen, isDeleting, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl border dark:border-gray-700 max-w-sm w-full">
        <div className="p-6">
          <h3 className="text-lg font-bold mb-2 text-gray-900 dark:text-white">Delete Report</h3>
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            Are you sure you want to delete this report? This action cannot be undone.
          </p>
          <div className="flex gap-3 justify-center flex-wrap">
            <button
              onClick={onCancel}
              disabled={isDeleting}
              className="px-6 py-2 rounded-lg bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-gray-100 hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              disabled={isDeleting}
              className="px-6 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 disabled:opacity-50 transition-colors flex items-center gap-2"
            >
              {isDeleting && <LoaderCircle className="w-4 h-4 animate-spin" />}
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
